import {
  Actions,
  BulkOrderCreate,
  ImportList,
  InboundHistory,
  InboundTrack,
  OutboundHistory,
  OutboundTrack,
  SingleOrderCreate,
} from "constant/permissionPaths";
import _filter from "lodash/filter";
import _head from "lodash/head";

export const getActionPermission = (userPermissions: any[], page: string, action: string) => {
  const customerPortalPermissions = _head(
    _filter(userPermissions, (item) => {
      return item?.name === "customer_portal";
    })
  );
  const currentPage = _head(
    _filter(customerPortalPermissions?.pages, (item) => {
      return item?.name === page;
    })
  );
  const currentAction = _head(
    _filter(currentPage?.actions, (item) => {
      return item?.name === action;
    })
  );
  return !!currentAction;
};

export const isTrackAllowed = (userPermissions: []) =>
  getActionPermission(userPermissions, InboundTrack, Actions.view) ||
  getActionPermission(userPermissions, OutboundTrack, Actions.view);

export const isOrderCreationAllowed = (userPermissions: []) =>
  getActionPermission(userPermissions, SingleOrderCreate, Actions.create) ||
  getActionPermission(userPermissions, BulkOrderCreate, Actions.create);

export const isHistoryAllowed = (userPermissions: []) =>
  getActionPermission(userPermissions, InboundHistory, Actions.view) ||
  getActionPermission(userPermissions, OutboundHistory, Actions.view);

export const isImportAllowed = (userPermissions: []) => {
  return getActionPermission(userPermissions, ImportList, Actions.viewFile);
};

export const getSelectCheckboxAccess = (userPermissions: [], currentTabPath) => {
  if (currentTabPath === InboundHistory) {
    return getActionPermission(userPermissions, currentTabPath, Actions.sendTrackingUrl);
  } else {
    return (
      getActionPermission(userPermissions, currentTabPath, Actions.sendTrackingUrl) ||
      getActionPermission(userPermissions, currentTabPath, Actions.print)
    );
  }
};

export const getPermittedCrnttab = (userPermissions: [], pathArr: Array<any>, inboundPath: string, outboundPath: string) => {
  const isInboundView = getActionPermission(userPermissions, inboundPath, Actions.view);
  const isOutboundView = getActionPermission(userPermissions, outboundPath, Actions.view);
  if(pathArr.length === 3) {
    const tab = pathArr[2];
    if(tab === "inbound")
      return isInboundView ?  "inbound" : "outbound";
    if(tab === "outbound")
      return isOutboundView ? "outbound" : "inbound";
  } else {
    return isInboundView ? "inbound" : "outbound";
  }
}
